import { useDAL } from '@/contexts/useDAL';

import { AccountIndicator } from '../accountIndicator';

export const RestoreAccountIndicator = ({
  providerAccountId,
  showCloudIndicator = true,
  showAccountName = true,
  showAccountId = true,
  copyable = true,
}: {
  providerAccountId: string;
  showCloudIndicator?: boolean;
  showAccountName?: boolean;
  showAccountId?: boolean;
  copyable?: boolean;
}) => {
  const dal = useDAL();
  const { data: body } = dal.cloudAccounts.restore.useList();
  const account = body?.accounts.find(
    (a) => a.providerAccountId === providerAccountId
  );

  return account ? (
    <AccountIndicator
      account={account}
      showCloudIndicator={showCloudIndicator}
      showAccountName={showAccountName}
      showAccountId={showAccountId}
      copyable={copyable}
    />
  ) : null;
};
